import { TimeRange } from '@/infra/time-range'
import { set } from 'date-fns'
import { observable, action } from 'mobx'

/**
 * A day which maintains a list of time slots.
 */
export class ScheduledDayViewModel {
  @observable accessor day: Date = new Date()
  @observable accessor selectedTimeSlots: TimeRange[] = []
  @observable accessor availableTimeSlots: TimeRange[] = []

  constructor(day: Date, availableTimeSlots: TimeRange[]) {
    this.day = day
    this.availableTimeSlots = availableTimeSlots
  }

  /**
   * Selects all time slots in the list.
   *
   * @param times The time slots to select
   */
  @action.bound
  selectTimeSlots(times: TimeRange[]): void {
    this.selectedTimeSlots = times.filter((t) => t.isSameDay(this.day))
  }

  /**
   * Creates a TimeRange from a time slot for the current day.
   *
   * @param slot The time slot to convert
   * @returns A TimeRange adjusted for the current day
   */
  timeRangeForCurrentDay(slot: TimeRange): TimeRange {
    return new TimeRange(
      set(new Date(this.day), {
        hours: slot.startTime.getHours(),
        minutes: slot.startTime.getMinutes(),
        seconds: 0,
        milliseconds: 0,
      }),
      set(new Date(this.day), {
        hours: slot.endTime.getHours(),
        minutes: slot.endTime.getMinutes(),
        seconds: 0,
        milliseconds: 0,
      }),
    )
  }
}
